import { Component } from "@angular/core";

@Component({
  selector: "bit-table",
  templateUrl: "./table.component.html",
})
export class TableComponent {}
